__turbopack_context__.v({
  "list": "CoreList-module-scss-module__ciNX5W__list",
});
